/*
 * progressData — shared, read-only derivations over the engine's memory tree
 * and event snapshot, used by Practice and Progress so both tell the same story.
 */
const DAY = 86400000;
export const WEEK_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

/** Days-ago (0 = today) that carry a practice signal: every node's last-practised
 *  day plus the engine's recent events. A lower bound — the engine keeps only
 *  each topic's last day and its latest events. */
export const practiceDays = (memTree, events) => {
  const days = new Set();
  const walk = (nodes) => (nodes || []).forEach((n) => {
    if (n.attempts > 0 && n.last_seen_days != null) days.add(Math.floor(n.last_seen_days));
    walk(n.children);
  });
  walk(memTree);
  const now = Date.now();
  (events || []).forEach((e) => { const t = Date.parse(e.ts); if (t) days.add(Math.floor((now - t) / DAY)); });
  return days;
};

/** Consecutive days with practice, counting back from today (or yesterday). */
export const streakFrom = (days) => {
  let count = 0;
  let d = days.has(0) ? 0 : 1;
  while (days.has(d)) { count += 1; d += 1; }
  return count;
};

/** This calendar week (Mon–Sun): done / today / future per day. */
export const weekFrom = (days) => {
  const today = (new Date().getDay() + 6) % 7;   // Mon = 0
  return WEEK_LABELS.map((label, i) => ({ label, done: i <= today && days.has(today - i), today: i === today, future: i > today }));
};
